import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-digital-queue',
  templateUrl: './digital-queue.component.html',
  styleUrls: ['./digital-queue.component.scss'],
})
export class DigitalQueueComponent {
  id: string = "";
  constructor(private route: ActivatedRoute){
    
  }

  ngOnInit(): void {
    this.route.paramMap
    .subscribe(params => {
      this.id = params.get("id")??"";
    })
  }
}
